import { trendingItems } from '@/mocks/content';

export default function TrendingSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            Trending This Week
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Featured Spreadsheets
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Card 1 - Nike Shoes */}
          <div className="bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300 transition-colors group cursor-pointer">
            <div className="w-full h-[220px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20editorial%20photography%20of%20a%20pair%20of%20white%20and%20sage%20green%20fashion%20sneakers%20placed%20on%20textured%20kraft%20paper%20with%20dried%20eucalyptus%20leaves%20soft%20natural%20window%20light%20from%20left%20side%20minimalist%20composition%20warm%20earthy%20tones%20high%20detail%20product%20photography&width=800&height=500&seq=nike-sneaker-v2-2026&orientation=landscape"
                alt="Nike Shoes Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {trendingItems[0].name}
              </h3>
              <div className="flex items-center gap-4 text-xs text-foreground-500 mb-3">
                <span>{trendingItems[0].price}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {trendingItems[0].quality}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">Updated {trendingItems[0].updated}</span>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-primary-600 text-xs font-medium hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
                >
                  View Sheet
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Card 2 - Luxury Bags */}
          <div className="bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300 transition-colors group cursor-pointer">
            <div className="w-full h-[220px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20shot%20of%20a%20structured%20taupe%20leather%20handbag%20with%20gold%20hardware%20resting%20on%20natural%20linen%20fabric%20alongside%20a%20silk%20scarf%20diffused%20afternoon%20sunlight%20creating%20soft%20highlights%20artful%20editorial%20fashion%20photography%20warm%20neutral%20color%20palette&width=800&height=500&seq=luxury-bag-v2-2026&orientation=landscape"
                alt="Luxury Bags Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {trendingItems[1].name}
              </h3>
              <div className="flex items-center gap-4 text-xs text-foreground-500 mb-3">
                <span>{trendingItems[1].price}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {trendingItems[1].quality}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">Updated {trendingItems[1].updated}</span>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-primary-600 text-xs font-medium hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
                >
                  View Sheet
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Card 3 - Streetwear */}
          <div className="bg-white rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300 transition-colors group cursor-pointer">
            <div className="w-full h-[220px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20flatlay%20of%20oversized%20cream%20colored%20hoodie%20folded%20neatly%20with%20vintage%20wash%20denim%20jeans%20and%20a%20baseball%20cap%20on%20raw%20cotton%20canvas%20background%20soft%20natural%20daylight%20minimalist%20streetwear%20editorial%20style%20earthy%20neutral%20tones%20high%20resolution&width=800&height=500&seq=streetwear-v2-2026&orientation=landscape"
                alt="Streetwear Essentials List"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {trendingItems[2].name}
              </h3>
              <div className="flex items-center gap-4 text-xs text-foreground-500 mb-3">
                <span>{trendingItems[2].price}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {trendingItems[2].quality}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">Updated {trendingItems[2].updated}</span>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-primary-600 text-xs font-medium hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
                >
                  View Sheet
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}